import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UsersService } from 'src/app/users/users.service';
import { DeviceService } from 'src/app/home/site-dashboard/device/device.service';
import { ColumnsConfig, TableConfig, TableData} from 'sct-custom-table/sct-table/projects/sct-table/src/lib/custom-table-interface';
import * as _ from 'lodash';
import { Router } from '@angular/router';
import { ModalComponent } from 'src/app/shared/modal/modal.component';
import { TranslateService } from '@ngx-translate/core';
import { saveAs } from 'file-saver';
import { NotificationMessageService } from 'src/app/shared/notification-message/notification-message.service';
import { AngularCsv } from 'angular-csv-ext/dist/Angular-csv';
import { CommonDataService } from 'src/app/shared/services/common-data.service';
import * as abbreviations from '../../../../../Common/abbreviations.json';
import * as moment from 'moment';
import { SCTCustomTable } from 'sct-custom-table/sct-table/projects/sct-table/src/lib/sct-table.component';
import { CommonService, TimeSource } from 'src/app/shared/services/common.service';

@Component({
	selector: 'disconnected-sites-report.component',
	templateUrl: './disconnected-sites-report.component.html',
	styleUrls: ['./disconnected-sites-report.component.css']
})
export class DisconnectedSitesComponent implements OnInit, OnDestroy {
	@ViewChild("popupModal") popupModal: ModalComponent;
	@ViewChild("sctCustomTable", { static: true }) sctCustomTable!: SCTCustomTable;
	percentage = 0;
	daysCount = 0;
	sitesData: any[] = [];
	selectedDisconnectedDevices: any[] = [];

	selectedState: string[] = [];
	abbreviation = abbreviations;
	stateFilterOptions:any[] = []
	isValidPercent = true;
	isValidDaysCount = true;
	isSmartRebatesSitesFilter: boolean = false;
	tableConfig: TableConfig = {
		hasExport: false,
		hasPagination: false,
	};

	sortedToShowData: any;

	/**
	 * Which time zone each time column is rendered in. See ST-2326.
	 * Selected as extract(epoch from s.installation_date) and rendered unmodified, so it is
	 * an absolute instant. The column is hidden by default.
	 */
	private readonly timeSourceByColumn: Record<string, TimeSource> = {
		site_installation_date: TimeSource.Utc,
	};

	columnConfig: ColumnsConfig[] = [
		{ key: 'customer_name', name: this.translateService.instant('g.customer_name'), type: 'link' },
		{ key: 'site_name', name: this.translateService.instant('g.site_name'), type: "link" },
		{ key: 'country', name: this.translateService.instant('site_edit.country'), type: "string" },
		{ key: 'site_state', name: this.translateService.instant('site_edit.state'), type: "string" },
		{ key: 'site_city', name: this.translateService.instant('smart_rebates_reports.city'), type: "string" },
		{ key: 'site_address', name: this.translateService.instant('g.site_address'), type: "string" },
		{ key: 'installer_name', name: this.translateService.instant('site.installer_name'), type: "string" },
		{ key: 'sales_person_name', name: this.translateService.instant('site.sales_person_name'), type: "string" },
		{ key: 'site_installation_date', name: this.translateService.instant('site.site_installation_date'), type: "date", hidden: true },
		{ key: 'disconnected_devices', name: this.translateService.instant('connectivity.num_disconnected_devices'), type: "number_link" },
		{ key: 'total_devices_number', name: this.translateService.instant('connectivity.devices_total_number'), type: "number" },
		{ key: 'percentage', name: this.translateService.instant('connectivity.percentage_col'), type: "number" },
	];

	constructor(
		private usersService: UsersService,
		private deviceService: DeviceService,
		private router: Router,
		private translateService: TranslateService,
		private notificationMessage: NotificationMessageService,
		private commonService: CommonDataService,
		private common: CommonService,
	) { }

	ngOnInit() {
		this.common.applyTimeSourceTooltips(this.columnConfig, this.timeSourceByColumn);

		if (!this.usersService.hasAccessPermission(null, 'noc'))
			this.router.navigate(['/unauthorized']);

		this.stateFilterOptions = [...Object.keys(this.abbreviation[this.commonService.SITE_LOCATION_STATE.usa]), this.commonService.SITE_LOCATION_STATE.Canada].sort((a, b) => a.localeCompare(b));
	}

	getDisconnectedSiteData() {
		const filterOptions = {
			percentage: this.percentage,
			daysCount: this.daysCount,
			siteStateFilter: this.selectedState,
			isSmartRebatesSitesFilter: this.isSmartRebatesSitesFilter
		};

		this.deviceService.getDisconnectedSitesReport(filterOptions).subscribe((response: any) => {
			const tableData: any = [];
			[...response].forEach(record => {
				let rowData: TableData = {
					record,
					customer_name: { value: record.customer_name == 'customer_deleted' ? this.translateService.instant('g.customer_deleted') : record.customer_name, link: record.customer_name == 'customer_deleted' ? null : ['/', record.customer_id] },
					site_name: { value: record.site_name == 'site_deleted' ? this.translateService.instant('g.site_deleted') : record.site_name, link: record.site_name == 'site_deleted' ? null : ['/', record.customer_id, record.site_id] },
					site_address: { value: record.site_address },
					installer_name: { value: record.installer_name },
					sales_person_name: { value: record.sales_person_name },
					site_state: { value: record.site_state },
					site_city: { value: record.site_city },
					country: { value: record.country },
					site_installation_date: { value: record.site_installation_date, sortValue: moment(record.site_installation_date).unix() * 1000 },
					disconnected_devices: { value: record.disconnected_devices.length, action: () => { this.showDisconnectedDeviseDataPopup(record.disconnected_devices) } },
					total_devices_number: { value: record.total_devices_number },
					percentage: { value: record.percentage?.toFixed(2) + "%", sortValue: +record.percentage?.toFixed(2) }
				}
				tableData.push(rowData);
			});
			this.sitesData = tableData;
		});
	}

	showDisconnectedDeviseDataPopup(disconnectedDevices) {
		this.popupModal.show();
		this.selectedDisconnectedDevices = disconnectedDevices;
	}

	checkValidation() {
		this.isValidPercent = this.percentage != null && this.percentage >= 0 && this.percentage <= 100;
		this.isValidDaysCount = this.daysCount != null && this.daysCount >= 0;
	}


	exportToPDF() {
		const filterOptions = {
			percentage: this.percentage,
			daysCount: this.daysCount,
			siteStateFilter: this.selectedState,
			isSmartRebatesSitesFilter: this.isSmartRebatesSitesFilter,
			columns: this.getTableColumns()
		};

		this.deviceService.getDisconnectedSitesReportAsPDF(filterOptions).subscribe((res: any) => {
			switch (res.api_status) {
				case 2:
					return this.notificationMessage.setMessage('translate|official_report.no_report_data', { clearOnXTimeNavigate: 1 });
				default:
					this.downloadReport(res);
					break;
			}
		});
	}

	exportToCsvFile() {
		const headersInfo = this.common.getCsvFileHeadersInfo({});
		const csvRows = [...headersInfo];

		const columnsTranslation = {
			customer_name: this.translateService.instant('g.customer_name'),
			site_name: this.translateService.instant('g.site_name'),
			country: this.translateService.instant('site_edit.country'),
			site_state: this.translateService.instant('site_edit.state'),
			site_city: this.translateService.instant('smart_rebates_reports.city'),
			site_address: this.translateService.instant('g.site_address'),
			installer_name: this.translateService.instant('site.installer_name'),
			sales_person_name: this.translateService.instant('site.sales_person_name'),
			site_installation_date: this.translateService.instant('site.site_installation_date'),
			disconnected_devices: this.translateService.instant('connectivity.num_disconnected_devices'),
			total_devices_number: this.translateService.instant('connectivity.devices_total_number'),
			percentage: this.translateService.instant('connectivity.percentage_col')
		}

		const tableColumns = this.getTableColumns();
		const columnNames = [];

		tableColumns.forEach(column => {
			columnNames.push(columnsTranslation[column]);
		});

		csvRows.push(columnNames);

		(this.sortedToShowData || []).forEach(row => {
			const csvRow = [];
			tableColumns.forEach(column => {
				csvRow.push(row[column].value || '-');
			});
			csvRows.push(csvRow);
		});

		new AngularCsv(csvRows, this.translateService.instant('connectivity.disconnected_sites_Report'));
	}

	downloadReport(data: any) {
		if (!data) return;
		const arr = new Uint8Array(data.content.data);
		const blob = new Blob([arr]);
		if (blob)
			saveAs(blob, data.name);
	}

	getTableSortedData(data) {
		this.sortedToShowData = data;
	}

	ngOnDestroy() {
		this.popupModal.hide();
	}

	getTableColumns() {
		let columns = [];
		if(this.sctCustomTable)
			columns =  this.sctCustomTable.shownColumnsConfig.map(col => col.key);

		return columns;
	}
}
